import script from "./MediaThumb.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaThumb.vue?vue&type=script&setup=true&lang=js"

import "./MediaThumb.vue?vue&type=style&index=0&id=7981f780&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7981f780"]])

export default __exports__